var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.className,attrs:{"src":require(("@/assets/images/" + _vm.name + ".svg")),"alt":_vm.name,"width":_vm.width}})}
var staticRenderFns = []

export { render, staticRenderFns }